var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreadcrumbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 350",
    style: {
      enableBackground: "new 0 0 350 350"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M275.7,169.5l2.2,5.5l-26,65.3c-4.6,11.4,9.8,20.9,18.5,12.2l69.5-69.5c4.4-4.4,4.4-11.6,0-16l-69.5-69.5 c-8.7-8.7-23.1,0.8-18.5,12.2l15,37.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.6,167l-69.5-69.5c-8.7-8.7-23.1,0.8-18.5,12.2l26,65.3l-26,65.3c-4.6,11.4,9.8,20.9,18.5,12.2l69.5-69.5 C216,178.6,216,171.4,211.6,167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.2,117.9L26.8,97.5c-8.7-8.7-23.1,0.8-18.5,12.2l26,65.3l-26,65.3c-4.6,11.4,9.8,20.9,18.5,12.2L96.3,183 c4.4-4.4,4.4-11.6,0-16l-32.5-32.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbs);
export default __webpack_public_path__ + "static/media/breadcrumbs.40bffb43770dedfd02dbd57b3e61d014.svg";
export { ForwardRef as ReactComponent };